import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  // Url of the Identity Provider
  // INFO: Issuer is set by environment.authenticationServer and overwritten by the value in env.json
  issuer: undefined,

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/auth',

  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: 'Kpd.UserManagement.Web',

  responseType: 'id_token token',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: '',

  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  showDebugInformation: true,

  // Map with additional query parameter that are appended to
  // the request when initializing implicit flow.
  customQueryParams: {
    acr_values: 'suppressDisallowedScopes',
  },

  postLogoutRedirectUri: window.location.origin,
};
